export const CUSTOM_FABRIC_ORDER_EVENT = 'CUSTOM_FABRIC_ORDER_EVENT'
export const CUSTOM_CERTIFICATE_TAB_CHANGE = 'CUSTOM_CERTIFICATE_TAB_CHANGE'

export const orderObjectEvent = new Event(CUSTOM_FABRIC_ORDER_EVENT)
export const certificateTabChangeEvent = new Event(
  CUSTOM_CERTIFICATE_TAB_CHANGE,
)
